import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Load layout components
import PageSpinner from '../components/layout/PageSpinner';
import ContributorsComponent from '../components/contributors/ContributorsComponent';
import { GlobalContext } from '../store/Provider';

// Context

const Contributors = () => {
  const { contributorsState } = useContext(GlobalContext);
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1>{t('contributors.name')}</h1>
      {contributorsState.contributors.fetching ? (
        <PageSpinner msg={t('general.stillFetchingData')} />
      ) : (
        <ContributorsComponent />
      )}
    </Fragment>
  );
};

export default Contributors;
